import React from 'react';
import styles from '../HATVDashboard.module.scss';
import Button from '../../../common/Button/Button';
import { useTranslation } from 'react-i18next';

interface HATVBulkActionBarProps {
  selectedItems: number;
  selectedOptionKey: string;
  selectedBulkAction: string | null;
  onCancel: () => void;
  onSave: () => void;
}

const HATVBulkActionBar: React.FC<HATVBulkActionBarProps> = ({
  selectedItems,
  selectedOptionKey,
  selectedBulkAction,
  onCancel,
  onSave,
}) => {
  const { t } = useTranslation();

  if (!selectedBulkAction) return null;

  return (
    <div className={styles.bulk_container_management}>
      <div className={styles.bulk_management_text}>
        <span className={styles.bulk_bald}>{selectedItems}</span> {t('hatvdashboard_account_selected')}{' '}
        <span className={styles.bulk_bald}>{t(selectedOptionKey)}</span>
      </div>
      <div className={styles.btn_wrapper}>
        <span className={styles.cancel_button} onClick={onCancel} data-testid="bulk_cancel">
          {t('btnCancel')}
        </span>
        <Button
          id="approveButton"
          onClick={onSave}
          label={
            selectedBulkAction === 'hatvdashboard_bulk_route'
              ? t('hatvdashboard_route_btn')
              : t('Approve')
          }
          style="filled"
          className={styles.approve_button}
          data-testid="bulk_save"
          isDisabled={selectedItems === 0}
        />
      </div>
    </div>
  );
};

export default HATVBulkActionBar;